// based on https://github.com/kimuraz/vue-rest/blob/dev/index.js
import Vue from 'vue';
import axios from 'axios';
import store from '@/store';
import forEach 			from 'lodash/forEach';

var sha256 = require('js-sha256').sha256;
function ksort(obj){
	var keys = Object.keys(obj).sort(), sortedObj = {};
	for(var i in keys) {
		sortedObj[keys[i]] = obj[keys[i]];
	}
	return sortedObj;
}

/**
ksort($postData);
foreach ($postData as $key => $value) {
    if ($key !== '_format' && $key !== 'shaSignature') {
        $hash .= strtoupper($key) . '=' . $value . $this->secret . '?';
    }
}
$shaSignature = $hash;
**/
const secret = "";
const ignore_keys = ["_format", "shaSignature"];

function getHash(obj){
	let tokens = "";
	if(obj instanceof FormData){
		let nobj = {};
		for(var pair of obj.entries()) {
			nobj[pair[0]] = pair[1];
		}

		forEach(ksort(nobj), (v, k) => {
			if(typeof k === "string" && !ignore_keys.includes(k)) tokens += k.toUpperCase() + '=' + v + secret + '?';
		});
	} else {
		obj = ksort(obj);
		forEach(obj, (v, k) => {
			if(typeof k === "string" && !ignore_keys.includes(k)) tokens += k.toUpperCase() + '=' + v + secret + '?';
		});
	}
	return sha256(tokens);
}


var ApiService = function(){}
ApiService.prototype.handleError = function(apierrorcode){
	switch(apierrorcode){
		case 10080: // logout user
			store.commit('orm/LOGOUT_CUSTOMER')
			return true;
	}

	return false;
}
ApiService.prototype.createError = function(message, statuscode, apierrorcode){
	var e = new Error(message);
	if(typeof statuscode !== 'undefined') e.statusCode = statuscode
	if(typeof apierrorcode !== 'undefined') e.apierrorcode = apierrorcode
	return Promise.reject(e);
}

ApiService.prototype.getResponseError = function(response){
	if(typeof response.data !== 'undefined') {
		if(typeof response.data.errorMessage !== 'undefined') {
			if(this.handleError(response.data.apiErrorCode)) return false;
			return this.createError(response.data.errorMessage, response.data.code, response.data.apiErrorCode);
		}

		if(typeof response.data.result !== 'undefined' && typeof response.data.result.errorMessage !== 'undefined') {
			if(this.handleError(response.data.result.apiErrorCode)) return false;
			return this.createError(response.data.result.errorMessage, response.data.result.code, response.data.result.apiErrorCode);
		}
	}

	if(typeof response.success !== 'undefined') {
		 return new Error("Unknown response error");
	}

	return false;
}

ApiService.prototype.processApiCatch = function(error){
	if(typeof error.response == 'object') return this.getResponseError(error.response);
	return error;
}

const VueApi = {
	install(Vue, options) {

		if (Vue.vueApi) return;
		Vue.vueApi = true;

		let api = null;
		if (options && options.axiosOptions) {
			api = axios.create(options.axiosOptions);

			if (options.axiosOptions.localStorageAuthorization) {

				const localStorageAuthorization = options.axiosOptions.localStorageAuthorization;

				api.interceptors.request.use((config) => {
					const token = localStorage.getItem(localStorageAuthorization.tokenItem);
					const prefix = localStorageAuthorization.prefix;

					if (!localStorageAuthorization.tokenItem || !prefix) {
						console.error('[ERR - VueApi]: Miss configuration at localStorageAuthorization.');
					}

					if (token) {
						Object.assign(config.headers, { Authorization: `${prefix} ${token}` , 'Content-Type': 'application/x-www-form-urlencoded' });
					}

					return config;
				});
			}
		}
		if (!api) {
			api = axios.create({
				transformResponse: axios.defaults.transformResponse.concat(function (data, headers) {
					if(typeof data !== 'object' && data !== ""){
						return Promise.reject('got html page, expected json')
					}

				    return data;
				}),
				baseURL: process.env.API_URL,
			});
		}

		api.interceptors.request.use(function (config) {
			var authcode = "cx9demo";

			if(config.method == 'get') {
				//config.params.authcode = authcode;
				//config.params.shaSignature = getHash(config.params);
			} else {

				if(config.data instanceof FormData){
					//config.data.set('authcode', authcode);
				//	config.data.set('shaSignature', getHash(config.data));
				} else {
					if(typeof config.data === 'undefined') config.data = {};
					//config.data.authcode = authcode;
				//	config.data.shaSignature = getHash(config.data);
				}
			}

			return config;
		});

		if(!api.defaults.params) api.defaults.params = {};
		var apiservice = new ApiService();
		Vue.api = api;
		Vue.apiservice = apiservice;
		Vue.prototype.$api = api;
		Vue.prototype.$apiservice = apiservice;
	},
};

export default VueApi;



// WEBPACK FOOTER //
// ./src/VueApi.js